import * as React from "react";

export const CalendarDollarIcon: React.FC<{
  className?: string;
  size?: number;
}> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.75 1H4.75C4.6 1 4.5 1.1 4.5 1.25V3.25C4.5 3.4 4.6 3.5 4.75 3.5H5.75C5.9 3.5 6 3.4 6 3.25V1.25C6 1.1 5.9 1 5.75 1Z"
      fill="#38724E"
    />
    <path
      d="M7.5 12.85H6V11.25C6 11.1 6.1 11 6.25 11H7.25C7.4 11 7.5 11.1 7.5 11.25V12.85Z"
      fill="#499B45"
    />
    <path
      d="M7.25 20.0004H6.25C6.1 20.0004 6 19.9004 6 19.7504V18.1504H7.5V19.7504C7.5 19.9004 7.4 20.0004 7.25 20.0004Z"
      fill="#499B45"
    />
    <path
      d="M6.74995 14.7496C6.34995 14.7496 5.99995 14.4496 5.99995 14.0496C5.99995 13.6496 6.34995 13.3496 6.74995 13.3496C7.09995 13.3496 7.39995 13.4996 7.44995 13.7496C7.49995 13.8496 7.59995 13.9496 7.69995 13.9496H8.69995C8.84995 13.9496 8.94995 13.7996 8.94995 13.6496C8.79995 12.5996 7.84995 11.8496 6.69995 11.8496C5.44995 11.8496 4.44995 12.8496 4.44995 14.0496C4.44995 15.2496 5.44995 16.2496 6.69995 16.2496C7.09995 16.2496 7.44995 16.5496 7.44995 16.9496C7.44995 17.3496 7.09995 17.6496 6.69995 17.6496C6.34995 17.6496 6.04995 17.4996 5.99995 17.1996C5.99995 17.0996 5.89995 16.9996 5.79995 16.9996H4.79995C4.59995 16.9996 4.49995 17.1496 4.49995 17.2996C4.64995 18.3496 5.59995 19.0996 6.74995 19.0996C7.99995 19.0996 8.99995 18.0996 8.99995 16.8996C8.99995 15.6996 7.99995 14.7496 6.74995 14.7496Z"
      fill="#499B45"
    />
    <path
      d="M5.75 1H4.75C4.6 1 4.5 1.1 4.5 1.25V3.25C4.5 3.4 4.6 3.5 4.75 3.5H5.75C5.9 3.5 6 3.4 6 3.25V1.25C6 1.1 5.9 1 5.75 1Z"
      fill="#38724E"
    />
    <path
      d="M19.25 17.5H13.25C13.1 17.5 13 17.6 13 17.75V18.75C13 18.9 13.1 19 13.25 19H19.25C19.4 19 19.5 18.9 19.5 18.75V17.75C19.5 17.6 19.4 17.5 19.25 17.5Z"
      fill="#38724E"
    />
    <path
      d="M19.25 12H13.25C13.1 12 13 12.1 13 12.25V13.25C13 13.4 13.1 13.5 13.25 13.5H19.25C19.4 13.5 19.5 13.4 19.5 13.25V12.25C19.5 12.1 19.4 12 19.25 12Z"
      fill="#38724E"
    />
    <path
      d="M18.25 3.5H19.25C19.4 3.5 19.5 3.4 19.5 3.25V1.25C19.5 1.1 19.4 1 19.25 1H18.25C18.1 1 18 1.1 18 1.25V3.25C18 3.4 18.1 3.5 18.25 3.5Z"
      fill="#38724E"
    />
    <path
      d="M20.3 4.5H3.7C2.2 4.5 1 5.7 1 7.2V20.35C1 21.85 2.2 23.05 3.7 23.05H20.35C21.85 23.05 23.05 21.85 23.05 20.35V7.2C23 5.7 21.8 4.5 20.3 4.5ZM3.7 6H20.35C21 6 21.55 6.55 21.55 7.2V8H2.5V7.2C2.5 6.55 3.05 6 3.7 6ZM20.3 21.5H3.7C3.05 21.5 2.5 20.95 2.5 20.3V9.5H21.5V20.3C21.5 20.95 20.95 21.5 20.3 21.5Z"
      fill="#38724E"
    />
  </svg>
);
